var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgFfLogo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2345 8.73397C23.6868 7.42069 22.5804 6.00373 21.71 5.55446C22.3292 6.75109 22.7601 8.03629 22.9853 9.36685C22.9853 9.36685 22.9852 9.37333 22.9874 9.38845C21.5649 5.84821 19.1508 4.42262 17.1805 1.31438C17.0787 1.1567 16.9791 0.994705 16.8839 0.832706C16.8341 0.748466 16.7886 0.662066 16.7453 0.573506C16.663 0.415827 16.6002 0.249507 16.5569 0.0767073C16.5569 0.0594273 16.5461 0.0443073 16.5288 0.0421473C16.5201 0.0399873 16.5136 0.0399873 16.505 0.0421473C16.505 0.0421473 16.5006 0.0443073 16.4985 0.0464673L16.4898 0.0507873L16.4941 0.0443073C13.333 1.8911 12.2591 5.31038 12.1617 7.01893C10.8994 7.10533 9.69122 7.56973 8.69741 8.35165C8.59349 8.26309 8.48523 8.18101 8.37048 8.10541C8.08251 7.10317 8.07169 6.04477 8.33583 5.03606C7.17531 5.59765 6.14254 6.39253 5.30462 7.37101H5.29813C4.79798 6.74029 4.83478 4.66022 4.86293 4.22606C4.7157 4.28438 4.57497 4.35998 4.44289 4.44854C4.00337 4.76174 3.58982 5.11382 3.21309 5.50046C2.78222 5.93677 2.39033 6.40549 2.03741 6.90661C1.22764 8.05141 0.653876 9.34309 0.348589 10.7104C0.342094 10.7384 0.337764 10.7665 0.331268 10.7924C0.307452 10.9026 0.223011 11.4556 0.207855 11.5765C0.207855 11.5852 0.207855 11.5938 0.205689 11.6046C0.0952667 12.177 0.0259818 12.758 0 13.3391C0 13.3607 0 13.3823 0 13.4039C0 20.3396 5.63589 25.9621 12.5882 25.9599C18.7177 25.9599 23.9574 21.5535 24.9945 15.5272C25.0162 15.3673 25.0335 15.2053 25.0508 15.0433C25.3106 12.9049 25.0292 10.7363 24.2345 8.73397ZM9.72803 18.5619C9.78649 18.59 9.84278 18.6203 9.9034 18.6483L9.91206 18.6548C9.84927 18.6246 9.78865 18.5943 9.72803 18.5619Z",
    fill: "url(#paint0_linear_8683_14225)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2345 8.73371C23.6868 7.42044 22.5804 6.00348 21.71 5.5542C22.3292 6.75084 22.7601 8.03603 22.9853 9.36659C22.9853 9.36443 22.9853 9.36875 22.9853 9.37739V9.39035C24.1739 12.6023 23.5287 15.8703 22.5955 17.8662C21.1535 20.955 17.6611 24.1194 12.1941 23.966C6.28977 23.7997 1.08474 19.4279 0.114753 13.6995C-0.0627894 12.7967 0.114753 12.3387 0.203524 11.6043C0.0822758 12.1746 0.0151561 12.7556 0 13.3388C0 13.3604 0 13.382 0 13.4036C0 20.3394 5.63589 25.9618 12.5882 25.9618C18.7177 25.9618 23.9574 21.5554 24.9945 15.5291C25.0162 15.3692 25.0335 15.2072 25.0508 15.0452C25.3106 12.9068 25.0292 10.7382 24.2345 8.73587V8.73371Z",
    fill: "url(#paint1_radial_8683_14225)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2345 8.73371C23.6868 7.42044 22.5804 6.00348 21.71 5.5542C22.3292 6.75084 22.7601 8.03603 22.9853 9.36659C22.9853 9.36443 22.9853 9.36875 22.9853 9.37739V9.39035C24.1739 12.6023 23.5287 15.8703 22.5955 17.8662C21.1535 20.955 17.6611 24.1194 12.1941 23.966C6.28977 23.7997 1.08474 19.4279 0.114753 13.6995C-0.0627894 12.7967 0.114753 12.3387 0.203524 11.6043C0.0822758 12.1746 0.0151561 12.7556 0 13.3388C0 13.3604 0 13.382 0 13.4036C0 20.3394 5.63589 25.9618 12.5882 25.9618C18.7177 25.9618 23.9574 21.5554 24.9945 15.5291C25.0162 15.3692 25.0335 15.2072 25.0508 15.0452C25.3106 12.9068 25.0292 10.7382 24.2345 8.73587V8.73371Z",
    fill: "url(#paint2_radial_8683_14225)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6098 10.9892C12.5882 11.3024 11.484 12.3781 11.0964 12.3781C7.51739 12.3781 6.93713 14.5381 6.93713 14.5381C7.09519 16.3568 8.36397 17.8559 9.90123 18.6486C9.97051 18.6831 10.042 18.7177 10.1134 18.7501C10.2347 18.8041 10.3581 18.8538 10.4837 18.9013C11.0098 19.0871 11.5619 19.1929 12.1227 19.2167C18.3951 19.5104 19.6119 11.7344 15.0846 9.47507C16.243 9.27419 17.4468 9.73859 18.1201 10.2095C16.9943 8.2266 14.8876 7.00188 12.6055 6.99756C12.4561 6.99756 12.311 7.01052 12.1638 7.01916C10.9015 7.10556 9.69337 7.56996 8.69957 8.35188C8.89227 8.51388 9.10878 8.72988 9.56563 9.17915C10.4187 10.0194 12.6098 10.8899 12.6142 10.9914L12.6098 10.9892Z",
    fill: "url(#paint3_radial_8683_14225)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6098 10.9892C12.5882 11.3024 11.484 12.3781 11.0964 12.3781C7.51739 12.3781 6.93713 14.5381 6.93713 14.5381C7.09519 16.3568 8.36397 17.8559 9.90123 18.6486C9.97051 18.6831 10.042 18.7177 10.1134 18.7501C10.2347 18.8041 10.3581 18.8538 10.4837 18.9013C11.0098 19.0871 11.5619 19.1929 12.1227 19.2167C18.3951 19.5104 19.6119 11.7344 15.0846 9.47507C16.243 9.27419 17.4468 9.73859 18.1201 10.2095C16.9943 8.2266 14.8876 7.00188 12.6055 6.99756C12.4561 6.99756 12.311 7.01052 12.1638 7.01916C10.9015 7.10556 9.69337 7.56996 8.69957 8.35188C8.89227 8.51388 9.10878 8.72988 9.56563 9.17915C10.4187 10.0194 12.6098 10.8899 12.6142 10.9914L12.6098 10.9892Z",
    fill: "url(#paint4_radial_8683_14225)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.11088 7.93269C8.19748 7.98885 8.28409 8.04717 8.3707 8.10549C8.08273 7.10325 8.0719 6.04485 8.33605 5.03613C7.17553 5.59773 6.14276 6.39261 5.30701 7.37109C5.36763 7.37109 7.19285 7.33653 8.11304 7.93269H8.11088Z",
    fill: "url(#paint5_radial_8683_14225)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.117425 13.7C1.08958 19.4262 6.29244 23.8002 12.1968 23.9643C17.6616 24.1177 21.154 20.9533 22.5982 17.8645C23.5314 15.8687 24.1787 12.6027 22.9901 9.38867V9.37571C22.9901 9.36707 22.9901 9.36059 22.9901 9.36491C22.9901 9.36923 22.9901 9.37139 22.9922 9.38651C23.4383 12.296 21.9551 15.1127 19.6363 17.0178L19.6298 17.0351C15.1133 20.7049 10.7895 19.249 9.91473 18.6529C9.85411 18.6226 9.79132 18.5924 9.7307 18.5622C7.09787 17.3072 6.0088 14.9118 6.24264 12.8598C4.9652 12.8792 3.79602 12.1448 3.26122 10.9892C3.26122 10.9892 5.25749 9.56795 7.88815 10.8035C9.37778 11.4795 11.0753 11.5443 12.6147 10.9892C12.6103 10.8877 10.4192 10.0172 9.56614 9.17699C9.1093 8.72771 8.89278 8.51171 8.70008 8.34971C8.59616 8.26115 8.4879 8.17907 8.37315 8.10347C8.29736 8.05163 8.21509 7.99763 8.11333 7.93067C7.1953 7.33451 5.37008 7.36907 5.30946 7.36907H5.30296C4.80281 6.73836 4.83962 4.65828 4.86777 4.22412C4.72054 4.28244 4.5798 4.35804 4.44773 4.4466C4.0082 4.7598 3.59466 5.11188 3.21792 5.49852C2.78706 5.93484 2.39516 6.40356 2.04224 6.90468C1.23248 8.04947 0.658713 9.34115 0.353426 10.7084C0.346931 10.7365 -0.101255 12.687 0.11959 13.6979L0.117425 13.7Z",
    fill: "url(#paint6_radial_8683_14225)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3843 10.4209C18.3237 10.3669 18.2609 10.3151 18.1959 10.2675C18.1699 10.2481 18.1439 10.2287 18.118 10.2092C17.4468 9.73834 16.2429 9.27394 15.0824 9.47482C19.6098 11.7342 18.3951 19.5102 12.1205 19.2164C11.5619 19.1948 11.0098 19.0868 10.4815 18.901C10.3559 18.8535 10.2325 18.8038 10.1112 18.7498C10.0398 18.7174 9.96833 18.685 9.89905 18.6483L9.90771 18.6548C10.7824 19.251 15.1062 20.7068 19.6227 17.037L19.6292 17.0197C19.7418 16.754 21.2358 13.0453 18.3821 10.4209H18.3843Z",
    fill: "url(#paint7_radial_8683_14225)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.9371 14.5377C6.9371 14.5377 7.51736 12.3778 11.0964 12.3778C11.4839 12.3778 12.5903 11.2999 12.6098 10.9889C11.0704 11.5462 9.37506 11.4792 7.88328 10.8031C5.25262 9.5676 3.25635 10.9889 3.25635 10.9889C3.79331 12.1445 4.96032 12.8789 6.23776 12.8594C6.00392 14.9114 7.093 17.3069 9.72582 18.5618C9.78428 18.5899 9.84057 18.6201 9.9012 18.6482C8.36394 17.8555 7.09516 16.3565 6.9371 14.5377Z",
    fill: "url(#paint8_radial_8683_14225)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2367 8.73348C23.6889 7.4202 22.5825 6.00325 21.7121 5.55397C22.3314 6.7506 22.7622 8.0358 22.9874 9.36636C22.9874 9.36636 22.9874 9.37284 22.9896 9.38796C21.5671 5.84773 19.1529 4.42213 17.1826 1.3139C17.0809 1.15622 16.9813 0.994217 16.886 0.832217C16.8362 0.747978 16.7907 0.661578 16.7474 0.573018C16.6652 0.415338 16.6024 0.249019 16.5591 0.076219C16.5591 0.058939 16.5483 0.0438191 16.5309 0.0416591C16.5223 0.0394991 16.5158 0.0394991 16.5071 0.0416591C16.5071 0.0416591 16.5028 0.0438191 16.5006 0.045979L16.492 0.050299L16.4963 0.0438191C13.3352 1.89062 12.2613 5.30989 12.1638 7.01844C12.3111 7.00764 12.4561 6.99684 12.6055 6.99684C14.8876 7.00116 16.9943 8.22588 18.1202 10.2088C17.449 9.73788 16.2451 9.27348 15.0846 9.47436C19.6119 11.7337 18.3973 19.5097 12.1227 19.2159C11.5641 19.1943 11.012 19.0863 10.4837 18.9006C10.3581 18.8531 10.2347 18.8034 10.1134 18.7494C10.042 18.717 9.97052 18.6846 9.90124 18.6479L9.9099 18.6543C9.84927 18.6241 9.78648 18.5939 9.72586 18.5636C9.78432 18.5917 9.84061 18.6219 9.90124 18.65C8.36398 17.8573 7.0952 16.3604 6.93714 14.5395C6.93714 14.5395 7.51741 12.3796 11.0964 12.3796C11.484 12.3796 12.5904 11.3017 12.6098 10.9907C12.6055 10.8892 10.4144 10.0187 9.56131 9.17844C9.10446 8.72916 8.88795 8.51316 8.69525 8.35116C8.59132 8.2626 8.48306 8.18052 8.36831 8.10492C8.08035 7.10268 8.06952 6.04429 8.33367 5.03557C7.17315 5.59717 6.14037 6.39205 5.30462 7.37052H5.29813C4.79798 6.7398 4.83478 4.65973 4.86293 4.22557C4.7157 4.28389 4.57497 4.35949 4.44289 4.44805C4.00337 4.76125 3.58982 5.11333 3.21308 5.49997C2.78222 5.93629 2.39033 6.40501 2.03741 6.90612C1.22764 8.05092 0.653876 9.3426 0.348589 10.7099C0.342094 10.738 0.337764 10.766 0.331268 10.792C0.307452 10.9021 0.201359 11.4637 0.186203 11.5847C0.0887712 12.1636 0.028147 12.7489 0 13.3364C0 13.358 0 13.3796 0 13.4012C0 20.337 5.63589 25.9594 12.5882 25.9573C18.7177 25.9573 23.9574 21.5509 24.9945 15.5245C25.0162 15.3647 25.0335 15.2027 25.0508 15.0407C25.3106 12.9023 25.0292 10.7336 24.2345 8.73132L24.2367 8.73348Z",
    fill: "url(#paint9_linear_8683_14225)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8683_14225",
    x1: 22.7691,
    y1: 3.47222,
    x2: 2.56088,
    y2: 23.0754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8683_14225",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.4944 5.58766) scale(33.9602 34.4482)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.229287,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379306,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.549519,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.698095,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8683_14225",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.3337 13.5655) scale(26.392 26.119)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DB293D",
    stopOpacity: 0.34
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F5334B",
    stopOpacity: 0.09
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_8683_14225",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.8167 20.3638) scale(11.1808 12.2277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_8683_14225",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.7807 10.9485) scale(5.93754 7.21436)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_8683_14225",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.6381 1.83822) scale(8.8847 8.90113)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_8683_14225",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.0746 -3.8194) scale(42.4413 35.5401)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_8683_14225",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.9541 4.58083) scale(24.3276 23.8481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_8683_14225",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.5622 6.1825) scale(29.2763 26.1372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8683_14225",
    x1: 24.6168,
    y1: 1.35349,
    x2: 5.33503,
    y2: 21.0536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0075568,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.805708,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFfLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ff-logo.5dfcb383812844a326bbfee4039de095.svg";